import React from 'react';

// Components
import GeneralInfo from './GeneralInfo';
import PasswordUpdate from './PasswordUpdate';
import ProctoringInfo from '../Register/ProctoringInfo';
import Locations from './Locations';
import ProfilePhoto from '../Register/ProfilePhoto';
import Activate from '../Register/Activate';

class CheckupStep extends React.Component {
  render() {
    const { userData } = this.props.store.SessionStore;

    if(userData.forcePasswordReset) {
      switch(this.props.step) {
        case 1:
          return <GeneralInfo nextStep={this.props.nextStep} {...this.props} />;

        case 2:
          return <PasswordUpdate nextStep={this.props.nextStep} {...this.props} />;

        case 3:
          return <ProctoringInfo nextStep={this.props.nextStep} lock={true} {...this.props} />;

        case 4:
          return <Locations nextStep={this.props.nextStep} {...this.props} />;

        case 5:
          return <ProfilePhoto nextStep={this.props.nextStep} {...this.props} />;

        case 6:
          return <Activate nextStep={this.props.nextStep} {...this.props} />;

        default:
          return <GeneralInfo nextStep={this.props.nextStep} {...this.props} />;
      }
    } else {
      switch(this.props.step) {
        case 1:
          return <GeneralInfo nextStep={this.props.nextStep} {...this.props} />;

        case 2:
          return <ProctoringInfo nextStep={this.props.nextStep} lock={true} {...this.props} />;

        case 3:
          return <Locations nextStep={this.props.nextStep} {...this.props} />;

        case 4:
          return <ProfilePhoto nextStep={this.props.nextStep} {...this.props} />;

        case 5:
          return <Activate nextStep={this.props.nextStep} {...this.props} />;

        default:
          return <GeneralInfo nextStep={this.props.nextStep} {...this.props} />;
      }
    }
  }
}

export default CheckupStep;



// WEBPACK FOOTER //
// ./src/app/components/Checkup/CheckupStep.js